<template>
	<div class="partner_list">
		<el-tabs style="margin-left:10px;padding-top: 15px;" v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="待处理" name="0"></el-tab-pane>
			<el-tab-pane label="已处理" name="1"></el-tab-pane>
		</el-tabs>
		<!-- 表格 -->
		<el-table v-loading="loading" :data="tableData" style="width: 100%;min-height: 400px;">
			<el-table-column label="申请人" width="250" show-overflow-tooltip align="left">
				<template slot-scope="scope">
					<div class="hhrtx"> <img :src='scope.row.headimg' class="hhrimg" /></div>
					<span class="hhrname">{{scope.row.nickname}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="partner_oauth" label="经营者" align="center">
				<template slot-scope="scope">
					{{scope.row.partner_oauth?scope.row.partner_oauth:'--'}}
				</template>
			</el-table-column>
			<el-table-column prop="group_name" label="所在社群" width="250" align="center"></el-table-column>
			<el-table-column prop="user_num" label="用户数量" align="center">
				<template slot-scope="scope">
					{{formatNumber(scope.row.user_num)}}
				</template>
			</el-table-column>
			<el-table-column prop="channel" label="申请来源" align="center">
				<template slot-scope="scope">
					{{scope.row.channel?scope.row.channel:'--'}}
				</template>
			</el-table-column>
			<el-table-column prop="intention_type" width="120" label="申请意向" align="center">
				<template slot-scope="scope">
					{{scope.row.intention_type}}
				</template>
			</el-table-column>
			<el-table-column prop="create_time" label="申请时间" width="150" align="center"></el-table-column>
			<el-table-column prop="status" width="100px" label="审核状态" align="center">
				<template slot-scope="scope">
					<div v-if="scope.row.status == 1" style="color: #666666;">已同意</div>
					<div v-else-if="scope.row.status == 2" style="color: #666666;">已拒绝</div>
					<div v-else style="color: #666666;">待审核</div>
				</template>
			</el-table-column>
			<el-table-column prop="save" label="操作" width="150" fixed="right" align="center">
				<template slot-scope="scope">
					<template v-if="scope.row.status == 0">
						<el-button type="text" size="medium" @click="changeStatus(scope.row.id, 1,scope.row.intention_type,scope.row.nickname)">同意</el-button>
						<el-button type="text" size="medium" @click="changeStatus(scope.row.id, 2)">拒绝</el-button>
					</template>
					<el-button type="text" size="medium" @click="goDetail(scope.row.id)">详情</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页器 -->
		<div class="block" style="padding: 40px;background: #ffffff;">
			<el-pagination background align='center' @size-change="handleSizeChange"
				@current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
				layout="total, prev, pager, next, jumper" :pager-count='5' :total="total">
			</el-pagination>
		</div>
		
		<applyReject
		  :show="showRejectDialog"
		  @close="closeRejectDialog"
		  @confirm="confirmReject"
		></applyReject>
	</div>
</template>

<script>
	import {
		getApplyList,
		handleApply
	} from '../../api/partner';
	import applyReject from '@/components/partner/apply-reject.vue';
	export default {
		data() {
			return {
				activeName:'0',
				changeid: 0,
				Refused_desc: '',
				type: 0,
				tableData: [], //列表数据
				currentPage: 0, // 当前页码
				total: 0, // 总条数
				pageSize: 10, // 每页的数据条数
				loading: true,
				showRejectDialog: false,
			};
		},
		components: {
			applyReject
		},
		created() {
			this.currentPage = 0;
			this.getList();
		},
		methods: {
			handleClick(tab, event) {
				this.currentPage = 0;
				this.getList();
			},
			goDetail(id) {
				this.$router.push({
					path: '/customer/partner-apply-detail',
					query: {
						id: id,
					}
				});
			},
			formatNumber(value) {
				let isW = value >= 10000 ? true : false;
				return isW ? Math.floor((value / 10000) * 10) / 10 + 'w' : value;
			},
			changeStatus(id, type,intention_type,nickname) {
				this.changeid = id;
				this.type = type;
				if (type == 1) {
					this.changeApply(type,'',intention_type,nickname);
				} else {
					this.openRejectDialog();
				}
			},
			confirmReject(reason) {
				this.changeApply(2, reason);
			},
			changeApply(type, reason = '',intention_type='',nickname='') {
				var id = this.changeid;
				if(type==1){                
					this.$confirm('您确认同意【'+nickname+'】申请成为您的“'+intention_type+'”吗？', '提示', {
					  confirmButtonText: '确定',
					  cancelButtonText: '取消'
					}).then(() => {
						handleApply({
							'id': id,
							'type': type,
							'reason': reason
						}).then(res => {
							if (res.code == 50000) {
								this.$message.error(res.message);
							} else {
								if (res.code == 0) {
									this.$message.success(res.message);
									this.close_model();
								} else {
									this.$message.error(res.message);
									this.close_model();
								}
							}
						})
						return true;
					}).catch(() => {
					    return false;      
					});
				}else{
					handleApply({
						'id': id,
						'type': type,
						'reason': reason
					}).then(res => {
						if (res.code == 50000) {
							this.$message.error(res.message);
						} else {
							if (res.code == 0) {
								this.$message.success(res.message);
								this.close_model();
							} else {
								this.$message.error(res.message);
								this.close_model();
							}
						}
					})
				}
				
			},
			close_model() {
				this.currentPage = this.currentPage * 1 + 1;
				this.changeid = 0;
				this.showRejectDialog = false;
				this.getList();
			},
			getList() {
				this.loading = true;
				let currentPage = this.currentPage;
				if (currentPage > 0) {
					currentPage = currentPage - 1;
				}
				getApplyList({
					'start': currentPage * 10,
					'type':this.activeName
				}).then(res => {
					if (res.code == 0) {
						this.total = res.data.count;
						this.loading = false;
						this.tableData = res.data.list;
					} else {
						this.$message.error(res.message);
					}

				})
			},
			//每页条数改变时触发 选择一页显示多少行
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
			},
			//当前页改变时触发 跳转其他页
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getList();
			},
			showTips(obj, row) {
				/*obj为鼠标移入时的事件对象*/

				/*width为文本在页面中所占的宽度，创建标签，加入到页面，获取width,最后在移除*/
				let TemporaryTag = document.createElement('span');
				TemporaryTag.innerText = row.reason;
				TemporaryTag.className = 'getTextWidth';
				document.querySelector('body').appendChild(TemporaryTag);
				let currentWidth = document.querySelector('.getTextWidth').offsetWidth;
				document.querySelector('.getTextWidth').remove();

				/*cellWidth为表格容器的宽度*/
				const cellWidth = obj.target.offsetWidth

				/*当文本宽度小于||等于容器宽度时，代表文本显示未超过一行*/
				currentWidth <= cellWidth ? row.showTooltip = false : row.showTooltip = true,
					console.log(row.showTooltip);
			},
			openRejectDialog() {
				this.showRejectDialog = true;
			},
			closeRejectDialog() {
				this.showRejectDialog = false;
			},
		}
	};

	function trim(str) { //删除左右两端的空格
		return str.replace(/(^\s*)|(\s*$)/g, "");
	}
</script>

<style scoped>
	.father-main {
		overflow: auto;
	}

	.partner_list {
		min-height: 88vh;
		background: #fff;
	}

	.el-pagination.is-background .el-pager li {
		background: none;
	}

	.el-pagination.is-background .btn-next,
	.el-pagination.is-background .btn-prev {
		background: none;
	}

	.el-table th {
		text-align: center;
	}

	.hhrtx {
		display: inline-block;
		vertical-align: middle;
		padding: 0 15px;
	}

	.hhrimg {
		width: 40px;
		height: 40px;
		object-fit: cover;
		border-radius: 40px;
	}

	.hhrname {
		font-size: 14px;
		font-family: PingFang-SC-Medium, PingFang-SC;
		font-weight: 500;
		color: #333333;
	}

	.textarea_hei textarea {
		height: 150px;
	}

	.el-tooltip__popper {
		max-width: 20%;
	}

	.el-tooltip__popper,
	.el-tooltip__popper.is-dark {
		background: rgb(48, 65, 86) !important;
		color: #fff !important;
		line-height: 24px;
	}
</style>
